import { createLazyComponentWithSuspense } from '@/lib/createLazyComponentWithSuspense'

export const BookConsultant = createLazyComponentWithSuspense(() => import('@/pages/BookConsultant/BookConsultant'))

export const ReportSettings = createLazyComponentWithSuspense(() => import('@/pages/ReportSettings/ReportSettings'))

export const CorporateDiscountsAndRewardPrograms = createLazyComponentWithSuspense(
	() => import('@/pages/CorporateDiscountsAndRewardPrograms'),
)

export const HomePage = createLazyComponentWithSuspense(
	() => import('@/pages/HomePage/HomePage'),
	() => null,
	false,
)

export const Safety = createLazyComponentWithSuspense(() => import('@/pages/Safety/Safety'))

export const GeneralSettings = createLazyComponentWithSuspense(() => import('@/pages/GeneralSettings/GeneralSettings'))

export const ManageTravelers = createLazyComponentWithSuspense(() => import('@/pages/ManageTravelers/ManageTravelers'))

export const ManageDepartments = createLazyComponentWithSuspense(
	() => import('@/pages/ManageDepartments/ManageDepartments'),
)

export const ManageLocations = createLazyComponentWithSuspense(() => import('@/pages/ManageLocations/ManageLocations'))

export const ManageSyncSSOConfig = createLazyComponentWithSuspense(
	() => import('@/pages/ManageSyncSSOConfig/ManageSyncSSOConfig'),
)

export const ManagePolicy = createLazyComponentWithSuspense(() => import('@/pages/ManagePolicy/ManagePolicy'))

export const CompanyPolicySettings = createLazyComponentWithSuspense(
	() => import('@/pages/CompanyPolicySettings/CompanyPolicySettings'),
)

export const ExpensePolicySettings = createLazyComponentWithSuspense(
	() => import('@/pages/ExpensePolicySettings/ExpensePolicySettings'),
)

export const OfficePolicySettings = createLazyComponentWithSuspense(
	() => import('@/pages/OfficePolicySettings/OfficePolicySettings'),
)

export const PolicyGroupSettings = createLazyComponentWithSuspense(
	() => import('@/pages/PolicyGroupSettings/PolicyGroupSettings'),
)

export const ManageExpenses = createLazyComponentWithSuspense(() => import('@/pages/ManageExpenses/ManageExpenses'))

export const NewStandardExpense = createLazyComponentWithSuspense(
	() => import('@/pages/NewStandardExpense/NewStandardExpense'),
)

export const NewStandardExpenseInReport = createLazyComponentWithSuspense(
	() => import('@/pages/NewStandardExpense/NewStandardExpenseInReport'),
)

export const EditStandardExpense = createLazyComponentWithSuspense(
	() => import('@/pages/EditExpense/EditStandardExpense'),
)
export const EditStandardExpenseInReport = createLazyComponentWithSuspense(
	() => import('@/pages/EditExpense/EditStandardExpenseInReport'),
)

export const NewMileage = createLazyComponentWithSuspense(() => import('@/pages/NewMileage/NewMileage'))

export const NewMileageInReport = createLazyComponentWithSuspense(() => import('@/pages/NewMileage/NewMileageInReport'))

export const EditMileage = createLazyComponentWithSuspense(() => import('@/pages/NewMileage/EditMileage'))

export const EditMileageInReport = createLazyComponentWithSuspense(
	() => import('@/pages/EditExpense/EditMileageInReport'),
)

export const NewDailyAllowance = createLazyComponentWithSuspense(
	() => import('@/pages/NewDailyAllowance/NewDailyAllowance'),
)

export const NewDailyAllowanceInReport = createLazyComponentWithSuspense(
	() => import('@/pages/NewDailyAllowance/NewDailyAllowanceInReport'),
)

export const EditDailyAllowance = createLazyComponentWithSuspense(
	() => import('@/pages/EditDailyAllowance/EditDailyAllowance'),
)

export const EditDailyAllowanceInReport = createLazyComponentWithSuspense(
	() => import('@/pages/EditExpense/EditDailyAllowanceInReport'),
)

export const ReportsRouter = createLazyComponentWithSuspense(() => import('@/pages/ReportsRouter/ReportsRouter'))

export const Itinerary = createLazyComponentWithSuspense(
	() => import('@/pages/Itinerary/Itinerary'),
	() => null,
	false,
)

export const HotelResultPage = createLazyComponentWithSuspense(
	() => import('@/pages/HotelResultPage/HotelResultPage'),
	() => null,
	false,
)

export const TripBuilder = createLazyComponentWithSuspense(() => import('@/pages/TripBuilder/TripBuilder'))

export const TripProduct = createLazyComponentWithSuspense(() => import('@/pages/TripBuilder/TripProduct'))

export const TripProductSearch = createLazyComponentWithSuspense(
	() => import('@/pages/TripBuilder/TripProductSearch'),
	() => null,
	false,
)
export const TripsList = createLazyComponentWithSuspense(() => import('@/pages/Trips/Trips'))

export const ExpenseReports = createLazyComponentWithSuspense(() => import('@/pages/ExpenseReports/ExpenseReports'))

export const ExpenseReportsSubmitted = createLazyComponentWithSuspense(
	() => import('@/pages/ExpenseReportsSubmitted/ExpenseReportsSubmitted'),
)

export const NewExpenseReport = createLazyComponentWithSuspense(
	() => import('@/pages/NewExpenseReport/NewExpenseReport'),
)

export const EditExpenseReport = createLazyComponentWithSuspense(
	() => import('@/pages/EditExpenseReport/EditExpenseReport'),
)

export const SelectExpensesInReport = createLazyComponentWithSuspense(
	() => import('@/pages/SelectExpensesInReports/SelectExpensesInReports'),
)

export const EditTraveler = createLazyComponentWithSuspense(() => import('@/organisms/EditTraveler/EditTraveler'))

export const TravelerUnusedTickets = createLazyComponentWithSuspense(
	() => import('@/pages/TravelerProfileUnusedTickets'),
)

export const ChangePlan = createLazyComponentWithSuspense(() => import('@/pages/ChangePlan/ChangePlan'))

export const ActivateInvoiceProfile = createLazyComponentWithSuspense(
	() => import('@/pages/ActivateInvoiceProfile/ActivateInvoiceProfile'),
)

export const CreateInvoiceProfileWizard = createLazyComponentWithSuspense(
	() => import('@/pages/CreateInvoiceProfile/CreateInvoiceProfileWizard'),
)

export const InvoiceProfiles = createLazyComponentWithSuspense(() => import('@/pages/InvoiceProfiles/InvoiceProfiles'))

export const CurrentPlan = createLazyComponentWithSuspense(() => import('@/pages/CurrentPlan/CurrentPlan'))

export const UsageDetails = createLazyComponentWithSuspense(() => import('@/pages/UsageDetails/UsageDetails'))

export const CreateCompanyInvoices = createLazyComponentWithSuspense(
	() => import('@/pages/CompanyOnboarding/CreateCompanyInvoices'),
)

export const ConfirmCompanyPage = createLazyComponentWithSuspense(
	() => import('@/pages/CompanyOnboarding/ConfirmCompany'),
)

export const CallbackVerification = createLazyComponentWithSuspense(() => import('@/pages/CallbackVerification'))

export const CreditCardCallbackVerification = createLazyComponentWithSuspense(
	() => import('@/pages/CreditCardCallbackVerification/CreditCardCallbackVerification'),
)

export const PasswordChangeResult = createLazyComponentWithSuspense(
	() => import('@/pages/PasswordChangeResult/PasswordChangeResult'),
)

export const Support = createLazyComponentWithSuspense(() => import('@/pages/Support/Support'))

export const CreateTravelerProfile = createLazyComponentWithSuspense(
	() => import('@/pages/App/TravelerProfileUnpaidFee/CreateTravelerProfileRoute'),
)

export const TravelerProfileRoutes = createLazyComponentWithSuspense(
	() => import('@/pages/App/TravelerProfileUnpaidFee/TravelerProfileRoutes'),
)

export const TravelerProfileUnpaidFee = createLazyComponentWithSuspense(
	() => import('@/pages/App/TravelerProfileUnpaidFee/TravelerProfileUnpaidFee'),
)
